import { z } from 'zod';

export enum GenericMessageTypes {
  PREVIOUS_BUSINESS = 'PREVIOUS_BUSINESS',
  AUTHORIZED_USER_INVITE_CANCELED = 'AUTHORIZED_USER_INVITE_CANCELED',
  AUTHORIZED_USER_ALREADY_REGISTER = 'AUTHORIZED_USER_ALREADY_REGISTER',
  USER_LOCKED = 'USER_LOCKED',
  UBO_ALREADY_COMPLETE_ONBOARDING = 'UBO_ALREADY_COMPLETE_ONBOARDING',
  UBO_INVITE_LINK_EXPIRED = 'UBO_INVITE_LINK_EXPIRED',
}

export const genericMessageQueryParamsSchema = z.object({
  type: z.nativeEnum(GenericMessageTypes),
});
